export const translations = {
  export: {
    withEditors: {
      'en-150': 'With editors',
      'sk-SK': 'S redaktormi'
    },
    withDescription: {
      'en-150': 'With description',
      'sk-SK': 'S popisom'
    },
    backFromExport: {
      'en-150': 'Back to events',
      'sk-SK': 'Späť na udalosti'
    },
    jsonCopied: {
      'en-150': 'JSON has been copied',
      'sk-SK': 'JSON bol skopírovaný do schránky'
    },
    technicalExport: {
      'en-150': 'Technical export',
      'sk-SK': 'Technický export'
    },
    copyEvents: {
      'en-150': 'Copy to clipboard',
      'sk-SK': 'Kopírovať do schránky'
    },
    jsonExport: {
      'en-150': 'JSON export',
      'sk-SK': 'JSON export'
    },
    printExport: {
      'en-150': 'Print',
      'sk-SK': 'Vytlačiť'
    },
    day: {
      'en-150': 'Day',
      'sk-SK': 'Deň'
    },
    time: {
      'en-150': 'Time',
      'sk-SK': 'Čas'
    },
    event: {
      'en-150': 'Event',
      'sk-SK': 'Udalosť'
    },
    description: {
      'en-150': 'Description',
      'sk-SK': 'Popis udalosti'
    },
    method: {
      'en-150': 'Method',
      'sk-SK': 'Spôsob'
    },
    editors: {
      'en-150': 'Editors',
      'sk-SK': 'Redaktori'
    }
  }
}
